<template>
  <div class="content">
    <NavBar/>
    <div class="md-layout py-5">
      <div class="main_section">
        <h3 class="main_section-title">Finalize your booking</h3>
        <div class="main_section-content">
          <div v-if="errMsg" class="main_section-error">
            {{errMsg}}
          </div>
          <div v-else class="main_details-content">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
              <h3 class="main_details-title">Reservation Details</h3>
              <div class="main_details-item">
                <h4 class="main_details-subtitle">Dates</h4>
                <p class="main_details-text">{{getDate(reservationDetails.start_date)}} - {{getDate(reservationDetails.end_date)}}</p>
                <p class="main_details-line"></p>
              </div>
              <div class="main_details-item">
                <h4 class="main_details-subtitle">Guests</h4>
                <p class="main_details-text">{{reservationDetails.guests}} guests</p>
                <p class="main_details-line"></p>
              </div>
              <h3 class="main_details-title">Payment Information</h3>
              <div v-if="reservationDetails && reservationDetails.status" class="font-weight-bold main_details-subtitle">
                Status:  {{reservationDetails.status.name}}
              </div>
              <div v-if="reservationDetails && reservationDetails.status && reservationDetails.status.id != 6">
                <form @submit.prevent="submitForm">
                  <div class="main_details-item">
                    <h4 class="main_details-subtitle">Billing Address</h4>
                    <div class="md-layout">
                      <div class="md-layout-item md-small-size-100 md-size-50">
                        <md-field>
                          <label>Billing Address</label>
                          <md-input v-model="book_now_data.billing_address" md-placeholder="Billing Address"></md-input>
                        </md-field>
                        <span class="text-danger" v-if="book_errors.billing_address">
                        {{book_errors.billing_address[0]}}
                      </span>
                      </div>
                      <div class="md-layout-item md-small-size-100 md-size-50">
                        <md-field>
                          <label>City</label>
                          <md-input v-model="book_now_data.city" md-placeholder="City"></md-input>
                        </md-field>
                        <span class="text-danger" v-if="book_errors.city">
                        {{book_errors.city[0]}}
                      </span>
                      </div>
                      <div class="md-layout-item md-small-size-100 md-size-50">
                        <md-field>
                          <label>Country</label>
                          <md-input v-model="book_now_data.country" md-placeholder="Country"></md-input>
                        </md-field>
                        <span class="text-danger" v-if="book_errors.country">
                        {{book_errors.country[0]}}
                      </span>
                      </div>
                      <div class="md-layout-item md-small-size-100 md-size-50">
                        <md-field>
                          <label>Zip code</label>
                          <md-input v-model="book_now_data.zip_code" md-placeholder="Zip code"></md-input>
                        </md-field>
                        <span class="text-danger" v-if="book_errors.zip_code">
                        {{book_errors.zip_code[0]}}
                      </span>
                      </div>
                    </div>
                    <p class="main_details-line"></p>
                  </div>
                  <div class="main_details-item">
                    <h4 class="main_details-subtitle">Payment</h4>
                    <div class="md-layout">
                      <div class="md-layout-item md-small-size-100 md-size-50">
                        <div id="card-element"></div>
                      </div>
                    </div>
                    <p class="main_details-line"></p>
                  </div>
                  <md-button class="md-raised md-info" type="submit">Pay</md-button>
                  <span v-if="success_msg" class="font-weight-bolder d-flex">{{success_msg}}</span>
                  <span v-if="error_msg" class="text-danger large d-flex py-3">{{error_msg}}</span>
                </form>
              </div>

            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
              <h3 class="main_details-title">Price Details</h3>
              <div class="main_details-item">
                <h4 class="main_details-subtitle">Total price</h4>
                <p v-if="reservationDetails" class="main_details-text">{{getCurrencySymbol(reservationDetails.currency)}} {{reservationDetails.base_rate}}</p>
                <p class="main_details-line"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import {mapActions} from "vuex";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import { loadStripe } from '@stripe/stripe-js'
import axios from 'axios'
export default {
  name: "ReservationDetails",
  data() {
    return {
      unique_hash: '',
      reservationDetails: {},
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      errMsg: '',
      book_errors: [],
      success_msg: '',
      error_msg: '',
      stripe: null,
      cardElement: null,
      book_now_data: {
        listing_id: null,
        start_date: null,
        end_date: null,
        guests: null,
        first_name: null,
        last_name: null,
        email_address: null,
        phone_number: null,
        promotional_emails: 0,
        billing_address: null,
        city: null,
        country: null,
        zip_code: null,
        stripe_payment_method_id: null,
      }
    }
  },
  components: {
    NavBar,
    Footer
  },
  // async mounted() {
  //   this.stripe = await loadStripe('pk_test_WLuhnu2BUf2EoJq2saNXLzbI00hvtt25KH')
  //
  //   const elements = this.stripe.elements()
  //   this.cardElement = elements.create('card')
  //
  //   await this.$nextTick(() => {
  //     this.cardElement.mount("#card-element");
  //   });
  // },
  watch: {
    reservationDetails(newVal) {
      if (newVal && newVal.status && newVal.status.id != 6) {
        this.mountStripeCardElement()
      }
    }
  },
  async created() {
    if(this.$route.params.unique_hash) {
      localStorage.setItem('unique_hash', this.$route.params.unique_hash)
      this.unique_hash = this.$route.params.unique_hash
    } else {
      this.unique_hash = localStorage.getItem('unique_hash')
    }
    await this.getReservationDetails(this.unique_hash)
    .then(res => {
      if(res.response) {
        this.errMsg = res.response.data.error
        this.notifyVue('top', 'center')
        console.log(res.response.data.error, '_get error')
      } else {
        this.reservationDetails = res.data.data
        this.book_now_data.guests = this.reservationDetails.guests || 1
      }
    })
  },
  methods: {
    ...mapActions(['getReservationDetails']),
    async mountStripeCardElement() {
      const stripeKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
      if (!this.stripe) {
        // this.stripe = await loadStripe('pk_live_51PxYv400ZtcVqVEy1IKW4yE0uOhyQDJGo1w0X7uAneSZA1Yia193QTVSn1EfrEqfM2lXXlhk6wsPRk3pcGDN7Gyx007DkTv1kf')
        // this.stripe = await loadStripe('pk_test_WLuhnu2BUf2EoJq2saNXLzbI00hvtt25KH')
        this.stripe = await loadStripe(stripeKey)
      }
      const elements = this.stripe.elements()
      this.cardElement = elements.create('card')

      this.$nextTick(() => {
        const el = document.getElementById("card-element")
        if (el) {
          this.cardElement.mount("#card-element")
        }
      })
    },
    getCurrencySymbol(currencyCode) {
      try {
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        // Extract symbol by formatting a value and removing the digits
        const parts = formatter.formatToParts(1);
        const symbolPart = parts.find(part => part.type === 'currency');
        return symbolPart ? symbolPart.value : currencyCode;
      } catch (e) {
        return currencyCode; // fallback if the currency code is invalid
      }
    },
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        message:
            this.errMsg,
        icon: "event_busy",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: 'danger',
      });
    },
    getDate(input) {
      const date = new Date(input);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    async submitForm() {
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardElement,
        billing_details: {
          name: `${this.reservationDetails.first_name} ${this.reservationDetails.last_name}`,
          address: {
            line1: this.reservationDetails.billing_address,
            city: this.reservationDetails.city,
            postal_code: this.reservationDetails.zip_code,
            country: this.reservationDetails.country,
          },
        },
      })
      if (error) {
        alert(error.message)
        return
      }
      let baseURL = process.env.VUE_APP_BASE_URL
      try {
        await axios.post(`${baseURL}bookings/billing`, {
          stripe_payment_method_id: paymentMethod.id,
          reservation_id: this.reservationDetails.id,
          billing_address: this.book_now_data.billing_address,
          city: this.book_now_data.city,
          country: this.book_now_data.country,
          zip_code: this.book_now_data.zip_code,
        })
        .then(res => {
          if(res.status == 200 || res.status == 201) {
            this.success_msg = res.success
            setTimeout(() => {
              this.success_msg = ''
            }, 8000)
          }
        })
      } catch (err) {
        if(typeof(err.response.data.errors) == "string") {
         this.error_msg = err.response.data.errors
          setTimeout(() => {
            this.error_msg = ''
          }, 8000)
        } else {
          this.book_errors = err.response.data.errors
        }
        console.error(err)
      }
    }
  },
  beforeDestroy() {
    if (this.cardElement) {
      this.cardElement.unmount()
    }
  }
}
</script>

<style scoped lang="scss">
.text-success, .text-danger.large{
  font-size: 20px;
  font-weight: 500;
}
.main {
  &_section {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 90px 60px 50px;
    &-title {
      color: #000;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      padding-bottom: 30px;
      @media screen and (max-width: 1680px) {
        font-size: 28px;
      }
      @media screen and (max-width: 1440px) {
        font-size: 26px;
      }
      @media screen and (max-width: 768px) {
        font-size: 18px;
      }
      @media screen and (max-width: 440px) {
        font-size: 15px;
      }
    }
    &-content {
      margin: 15px 0;
    }
    &-error {
      padding: 20px;
      font-size: 20px;
      background: #f34242;
      color: #fff;
      font-weight: 600;
      margin-bottom: 50px;
    }
  }
  &_details {
    &-content {
      display: flex;
    }
    &-item {
      padding: 15px 0;
    }
    &-title {
      font-weight: 600;
      font-size: 24px;
    }
    &-subtitle {

    }
    &-text {

    }
    &-line {
      margin: 10px 0;
      border-bottom: 1px solid #1E1E1E;
    }
  }
}

</style>
